// Shared helpers + constants for the admin payments feature.
// See AdminPaymentsPage + the five subcomponents under /admin/payments/.

export const backend = process.env.REACT_APP_BACKEND_URL;

// ₹ with paise (invoices, timelines, reply preview). Full precision — money.
export const fmt = (n) =>
  `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// ₹ rounded (aging bars, overdue rollups). Chart labels stay narrow.
export const fmtCompact = (n) =>
  `₹${Math.round(Number(n || 0)).toLocaleString("en-IN")}`;

export const EVENT_FILTERS = [
  { key: "all", label: "All" },
  { key: "manual_reminder", label: "Manual" },
  { key: "cron_reminder", label: "Cron" },
  { key: "escalation", label: "Escalation" },
];

export const BUCKETS = [
  { key: "0_30", label: "0-30 days", color: "bg-amber-300" },
  { key: "31_60", label: "31-60 days", color: "bg-amber-500" },
  { key: "61_90", label: "61-90 days", color: "bg-orange-600" },
  { key: "90_plus", label: "90+ days", color: "bg-red-600" },
];

export const BUCKET_LABEL = {
  "0_30": "0-30",
  "31_60": "31-60",
  "61_90": "61-90",
  "90_plus": "90+",
};

export const STATEMENT_PRESETS = [
  "Please clear this by month-end so we can close the books.",
  "Post-holiday reminder — appreciate a quick UPI/NEFT.",
  "Second reminder — please share the payment reference at your earliest.",
  "Kindly clarify if there's a dispute; happy to jump on a call.",
];
